import { registerComponent, debounce } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "cart-note",
  class CartNote extends WYATTElement {
    constructor() {
      super();
      this.inputDelay = 500;
      this.noteInput = this.querySelector('[name="note"]');
      this.onNoteInput = debounce(
        this.onNoteChange.bind(this),
        this.inputDelay,
      );
    }

    connectedCallback() {
      if (this.noteInput) {
        this.noteInput.addEventListener("input", this.onNoteInput);
      }
    }

    disconnectedCallback() {
      if (this.noteInput) {
        this.noteInput.removeEventListener(this.onNoteInput);
      }
    }

    async onNoteChange(event) {
      try {
        const { value } = event.target;

        await fetch(`${WYATT.routes.cart_update_url}.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ note: value }),
        });
      } catch (e) {
        window.console.error(e);
      }
    }
  },
);
